import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";


import translationEN from "./locales/en/translation.json";
import translationAR from "./locales/ar/translation.json";

const resources = {
  en: {
    translation: translationEN
  },
  ar: {
    translation: translationAR
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    // Default to Arabic; fallback to English when keys missing
    fallbackLng: "ar",
    // Prefer previously saved locale, otherwise default to Arabic
    lng: localStorage.getItem("i18nextLng") || "ar",
    detection: {
      // prefer stored user choice, then navigator; avoid querystring/path by default
      order: ["localStorage", "navigator"],
      caches: ["localStorage"]
    },
    debug: false,
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  });

// Set initial direction and lang attribute
document.documentElement.dir = i18n.language === "ar" ? "rtl" : "ltr";
document.documentElement.lang = i18n.language;

// Keep document direction & lang in sync when language changes
i18n.on("languageChanged", (lng) => {
  document.documentElement.dir = lng === "ar" ? "rtl" : "ltr";
  document.documentElement.lang = lng;
});

export default i18n;
